<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<section *ngIf="products.length > 0" class="travel__upgrades__wrapper">
    <div class="travel__title">
        <h2 class="title">
            {{ 'fe_details_step3_travel_upgrades_title' | translate }}
        </h2>
    </div>
    <div class="travel__body">
        <div
            class="travel__card__wrapper"
            *ngFor="let product of products; let i = index"
        >
            <div class="travel__card" [ngClass]="{ active: isActive[i] }">
                <div class="travel__card__main">
                    <div class="travel__card__name">
                        <img alt="" [src]="getMeta(product).icon" />
                        <h3>{{ product.title }}</h3>
                    </div>
                    <p class="travel__card__tagline">
                        {{ getMeta(product).tagline | translate }}
                    </p>
                    <div
                        class="travel__card__details-wrap"
                        [class.open]="isActiveDetails[i]"
                    >
                        <button
                            class="travel__card__details"
                            (click)="toggleDetails(i)"
                        >
                            <img
                                class="travel__card__details-icon"
                                [class.open]="isActiveDetails[i]"
                                [src]="'images/chevron-alt-down.png' | cdn"
                                alt=""
                            />
                            <span>{{
                                (isActiveDetails[i]
                                    ? 'fe_details_step3_protection_level_button_info_hide'
                                    : 'fe_details_step3_travel_upgrades_button_info'
                                ) | translate
                            }}</span>
                        </button>
                        <div class="travel__popover" *ngIf="isActiveDetails[i]">
                            <button
                                class="travel__popover__close"
                                (click)="closeDetails(i)"
                            >
                                <span class="material-symbols-outlined">close</span>
                            </button>
                            <div
                                class="travel__popover__content"
                                [innerHTML]="product.description"
                            ></div>
                        </div>
                    </div>
                </div>
                <div class="travel__card__footer">
                    <span class="travel__card__price"
                        >{{ product.price | formatNumber }} {{ currency }}/{{
                            'fe_details_step3_protection_level_protection_card_middle_pay_day'
                                | translate
                                | lowercase
                        }}</span
                    >
                    <button
                        class="travel__card__add"
                        (click)="toggleActive(product, i)"
                    >
                        <span>{{
                            !isActive[i]
                                ? ('fe_details_step3_travel_upgrades_button_info_active'
                                  | translate)
                                : ('fe_details_step3_travel_upgrades_button_info_inactive'
                                  | translate)
                        }}</span>
                        <img
                            alt=""
                            [src]="
                                isActive[i]
                                    ? ('images/circle_eliminar.svg' | cdn)
                                    : ('images/plus-icon.svg' | cdn)
                            "
                        />
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>
